import {
    USER_LOGOUT,  FETCH_TRANSACTIONS,  RESET_TRANSACTIONS, ADD_TRANSACTION,FETCH_TRANSACTION,DELETE_TRANSACTION,UPDATE_TRANSACTION,
    REMOVE_SELECTED_TRANSACTIONS,ADD_SELECTED_TRANSACTIONS,CLEAR_SELECTED_TRANSACTIONS
} from "actions/actionTypes";
var _ = require('lodash');

const initialState = { SellerID: false, dataHash: {} ,data: [], fetched: false, total: 0, selectedTransactions: [] };
export default function (state = initialState, action) {
    switch (action.type) {

        case RESET_TRANSACTIONS:
            return initialState
        case FETCH_TRANSACTIONS: 
            let transactionDataHash = {}
            action.payload.data.forEach(record => {
                transactionDataHash[record._id] = record
            })
            return {
                ...state,
                data: action.payload.data,
                dataHash: transactionDataHash, //A hash with {id => transaction}
                SellerID: _.isUndefined(action.payload.SellerID) ? state.SellerID : action.payload.SellerID,
                total: action.payload.total,
                fetched: true
            }

        case UPDATE_TRANSACTION:
            var itemIndex = _.findIndex(state.data, {'_id': action.payload._id});
            
            const dataHash = { ...state.dataHash };
            dataHash[action.payload._id] = action.payload
            return {
                ...state,
                data: [...state.data.slice(0, itemIndex),
                    action.payload,
                    ...state.data.slice(itemIndex + 1)],
                dataHash: dataHash,     
                fetched: state.fetched
            }
        case ADD_TRANSACTION:
            state.dataHash[action.payload.data.id] = action.payload.data
            return {
                ...state,
                data: _.concat(state.data, [action.payload.data]),
                state: state.dataHash,
                fetched: state.fetched,
                total:state.total+1,
            }

        case ADD_SELECTED_TRANSACTIONS:
            var selectedTransactionsToAdd =_.map( action.payload, function (transaction) {
                return transaction._id;
            });
            var updatedSelectedTransactions = _.uniq(state.selectedTransactions.concat(selectedTransactionsToAdd));
            return {
                ...state,
                selectedTransactions: updatedSelectedTransactions
            }
        case CLEAR_SELECTED_TRANSACTIONS:
             return {
                ...state,
                selectedTransactions: []
            }
        case REMOVE_SELECTED_TRANSACTIONS:
             var selectedTransactionsToRemove =_.map( action.payload, function (transaction) {
                return transaction._id;
            });
            var updatedSelectedTransactions =  _.uniq(_.difference(state.selectedTransactions, selectedTransactionsToRemove));

            return {
                ...state,
                selectedTransactions: updatedSelectedTransactions,
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
// Get record by id
export const getTransaction = (state, id) => {
    return state.adminTransactions.dataHash[id];
}


